import MultiTabComponent from "@/manager/components/multi-tab-component/multi-tab-component";
import "./template-list.scss";
import TemplateTab from "./tabs/template-tab";
import Page from "@/manager/components/page/page";

const TemplateList = () => {
  return (
    <Page
      title={{ text: "Global Report Templates" }}
    >
    <div className="templateList">
      <div className="templateList-tabs">
        <MultiTabComponent
          displayNextButton={false}
          tabs={[
            {
              key: "analytics_report_template",
              name: "Report Templates",
              content: <TemplateTab templateType="analytics_report_template" />,
            },
            {
              key: "analytics_report_pdf_template",
              name: "PDF Templates",
              content: <TemplateTab templateType="analytics_report_pdf_template" />,
            },
          ]}
        />
      </div>
    </div>
    </Page>
  );
};

export default TemplateList;